module.exports = __webpack_public_path__ + "img/ico_info.9b54c43a.png";